import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { px2rem } from '@moim/common';
import { rgba } from 'polished';
import { withPlacement } from '../../hoc/withPlacement.mjs';
import styled from 'styled-components';

var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-ntcodn-0"
})(["width:100%;overflow:hidden;background-color:", ";", ";"], function (props) {
  return props.theme.colorV2.colorSet.white1000;
}, function (props) {
  return props.overrideStyle;
});
var LineElement = styled.div.withConfig({
  displayName: "LineElement",
  componentId: "sc-ntcodn-1"
})(["position:relative;width:100%;height:", ";background-color:", ";&::after{content:\"\";position:absolute;width:", ";height:", ";top:0;left:0;right:0;background-color:", ";}"], function (props) {
  return props.height ? px2rem(props.height) : px2rem(1);
}, function (props) {
  var _a, _b;
  return rgba((_b = props.theme.getColorByAlias((_a = props.backgroundColor) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main)) !== null && _b !== void 0 ? _b : "", 1);
}, function (props) {
  return "".concat(props.fillWidth, "%");
}, function (props) {
  return props.height ? px2rem(props.height) : px2rem(1);
}, function (props) {
  return props.theme.getColorByAlias(props.fillColor);
});
var Line = function Line(_a) {
  var wrapperStyle = _a.wrapperStyle,
    props = __rest(_a, ["wrapperStyle"]);
  return jsx(Wrapper, {
    overrideStyle: wrapperStyle,
    children: jsx(LineElement, Object.assign({}, props))
  });
};
var index = withPlacement(Line);

export { index as default };
